import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {Mental} from "../../Mental";
import {MentalHelper} from "../../utils/MentalHelper";
import {TimelineLite} from "gsap";
import {SoundManager} from "../../sound/SoundManager";
import {MentalSoundConfig} from "../../MentalSoundConfig";

export interface IDeadToActiveParams {
    reelId: number,
    symId: number,
    size: number,
    segment: number
}

export class DeadToActive extends PIXI.Container {
    public _burnAnim: TimelineSprite;
    public _anticipation: TimelineSprite;

    private _reelId: number;
    private _symId: number;
    private _symSize: number;
    private _symSegment: number;

    constructor() {
        super();

        this._burnAnim = DeadToActive.createPNGSeq("deadBurn");
        this._anticipation = DeadToActive.createAnticipation();

        this.addChild(this._burnAnim, this._anticipation);
    }

    private static createPNGSeq(assetName: string): TimelineSprite {
        let pngSeq: TimelineSprite = MentalHelper.createSprite(assetName);
        pngSeq.anchor.set(0.5, 0);
        pngSeq.hide();
        pngSeq.blendMode = PIXI.BLEND_MODES.MULTIPLY;

        return pngSeq;
    }

    private static createAnticipation(): TimelineSprite {
        const anim: TimelineSprite = DeadToActive.createPNGSeq("deadAnticipation");
        anim.scale.set(2);
        anim.position.y = -70;
        anim.blendMode = PIXI.BLEND_MODES.ADD;
        return anim;
    }

    public stopItems(): void {
        this._anticipation.stopLoop();
        this._anticipation.hide();

        this.visible = false;
    }

    public playAnimSeq(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        if (!(Mental.deadFeaturePresentation._activeIndex[this._reelId])) {
            tl.add(() => SoundManager.playSoundEffect(MentalSoundConfig.DEAD_TURN_ACTIVE), 0);
            tl.add(this._burnAnim.getAnimationAutoShowHide(true, true), 0);
        }

        tl.add(() => {
            this._anticipation.show();
            this._anticipation.playLoop();

            this.visible = true;
        }, 0);

        return tl;
    }

    // #299
    public adjustActiveAnimOnResize(height: number, absoluteIndexInReel: number): void {
        this.scale.y = (height / 198);
        this.y = (absoluteIndexInReel * height) + 99;
    }

    public setParams(params: IDeadToActiveParams): void {
        this._reelId = params.reelId;
        this._symId = params.symId;
        this._symSize = params.size;
        this._symSegment = params.segment;

        this.visible = false;

        this.init();
    }

    private init(): void {
        let defSymHeight: number = this.onEnhancer() ? 99 : 198,
            finalSymHeight: number = defSymHeight / this._symSize,
            mainScale: number[] = [1, (finalSymHeight / defSymHeight)],
            onFeatureReel: boolean = (this._reelId === 1 || this._reelId === 3),
            animPosX: number = Mental.reelArea.getReel(this._reelId).position.x,
            animPosY: number;

        if (onFeatureReel) {
            if (this.onEnhancer()) {
                animPosY = defSymHeight * 5 + ((defSymHeight / this._symSize) * this._symSegment);
                mainScale = [mainScale[0], (mainScale[1] / 2)];
            } else {
                animPosY = ((defSymHeight * this._symId) + ((defSymHeight / this._symSize) * this._symSegment)) + 99;
            }
        } else {
            animPosY = ((defSymHeight * this._symId) + ((defSymHeight / this._symSize) * this._symSegment));
        }

        this.scale.set(mainScale[0], mainScale[1]);
        this.position.set(animPosX, animPosY);
    }

    private onEnhancer(): boolean {
        return (this._symId === 2 && (this._reelId === 1 || this._reelId === 3));
    }
}